<template>
  <div :class="[isSmallScreen ? 'vertical-responsive-sm' : '', contentWidth === 'boxed' ? 'container p-0' : '']"  >
    <router-view />
    
    <!-- Loader -->
    <div class="loader" v-if="showLoader" id="mainloader">
      <img src="@/assets/images/svg/loader.svg" alt="" />
    </div>
    <!-- /Loader -->
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isSmallScreen: false,
    };
  },
  mounted() {
    this.checkScreenWidth();
    window.addEventListener('resize', this.checkScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenWidth);
  },
  methods: {
    checkScreenWidth() {
      this.isSmallScreen = window.innerWidth <= 992;
    },
  },
  computed: {
    ...mapGetters(["showLoader"]),
  },
  setup() {
    const { contentWidth } = useAppConfig()
    
    return { contentWidth }
  },
}
</script>

<style scoped lang="scss">
#mainloader {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    animation: flipX 1.3s linear infinite;
    width: 100px;
  }
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: -1;
    opacity: .3;
  }
}
@keyframes flipX {
  0% {
    transform: perspective(200px) rotateY(0deg) rotateY(0deg);
  }
  100% {
    transform: perspective(200px) rotateY(360deg) rotateY(0deg);
  }
}
</style>
